import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import MenuRemodeling from '../../components/MenuRemodeling';
import PaymentTypes from '../../components/PaymentTypes';
import PageSectionsAlternatingNoImage from '../../components/PageSectionsAlternatingNoImage';
import Gallery from './Gallery';

function DesignCenter({ page }) {
  if (!page) {
    return null;
  }

  return (
    <div>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuRemodeling />
        <PageIntroBanner
          heading={get(page, 'page_intro_banner[0].heading')}
          body={get(page, 'page_intro_banner[0].text')}
          image={get(page, 'page_intro_banner[0].image.contentUrl')}
        />
        <main>
          <PageSectionsAlternatingNoImage page={page} />
          <PaymentTypes />
          <Gallery photos={get(page, 'gallery[0].photos', [])} />
        </main>
      </PageWrapper>
    </div>
  );
}

DesignCenter.propTypes = {
  page: PropTypes.object,
};

DesignCenter.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'kitchen_remodels',
})(DesignCenter);



// WEBPACK FOOTER //
// ./src/pages/KitchenRemodels/index.js